export * from './LogoTelegramIcon';
export * from './LogoTelegramIcon16Light';
export * from './LogoTelegramIcon16Regular';
export * from './LogoTelegramIcon16Solid';
export * from './LogoTelegramIcon20Light';
export * from './LogoTelegramIcon20Regular';
export * from './LogoTelegramIcon20Solid';
export * from './LogoTelegramIcon24Regular';
export * from './LogoTelegramIcon24Solid';
export * from './LogoTelegramIcon32Regular';
export * from './LogoTelegramIcon64Regular';
